import { Component, OnDestroy, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Title } from "@angular/platform-browser";
import { ExtensionService } from "./athena-one-integration/shared/service/extension.service";
import { Router } from "@angular/router";
import { EXTENSION_MESSAGE } from "./athena-one-integration/shared/constants/scraped-data.constants";
import { takeUntil, tap, withLatestFrom } from "rxjs/operators";
import { Subject } from "rxjs";
import { ExtensionMessageSubscriberService } from "@ehrSharedResources/services/extension-message-subscriber/extension-message-subscriber.service";
import { EXTENSION_VERSION, LOCAL_STORAGE_KEYS } from "./shared/constants/local-storage.constants";
import { APP_EXTENSION_MESSAGE } from "./shared/constants/extension-message-constants";
import { ExtensionMessagePublisherService } from "@ehrSharedResources/services/extension-message-publisher/extension-message-publisher.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  manifestVersion: string | null = null;


  private _getExtensionVersion(): EXTENSION_VERSION | null {
    return localStorage.getItem(LOCAL_STORAGE_KEYS.ATHENA_EXTENSION_VERSION) as EXTENSION_VERSION | null;
  }

  private _processV2Extension(data: any) {
    if (data.type === APP_EXTENSION_MESSAGE.MANIFEST_VERSION) {
      this.manifestVersion = data.value?.manifestVersion || null;
    }

    if (this._getExtensionVersion() === EXTENSION_VERSION.VERSION_2) {
      if (data.type === APP_EXTENSION_MESSAGE.SCRAPPED_DATA) {
        this.extensionMessageSubscriber.processAthenaData(data.value);
      } else if (data.type === APP_EXTENSION_MESSAGE.LOGOUT) {
        this.extensionMessageSubscriber.logout();
      }
    }
  }

  private _processV1Extension(data: any) {
    if (this._getExtensionVersion() === EXTENSION_VERSION.VERSION_1) {
      this.extensionService.publishScrappedData(data);
    }
  }

  setDataValue(event: MessageEvent) {
    const data = event.data;
    if (data.version === 2) {
      this._processV2Extension(data);
    } else {
      this._processV1Extension(data);
    }
  }

  subscribeToDataValue() {
    this.extensionService.subscribeToScrappedData().pipe(
      withLatestFrom(this.extensionService.getExtensionError()),
      tap(([data, extensionError]) => {
        if (extensionError) {
          return;
        }
        console.log("Data received from extension:", data);
        if (data?.type === EXTENSION_MESSAGE.SCRAPPED_DATA || data?.type === EXTENSION_MESSAGE.LOGOUT || data === undefined) {
          localStorage.clear();
          localStorage.setItem("isExt", "1");
          localStorage.setItem(LOCAL_STORAGE_KEYS.ATHENA_EXTENSION_VERSION, EXTENSION_VERSION.VERSION_1);
          this.router.navigate(["/athena-one"], {
            skipLocationChange: true,
          });
        }
      }),
      takeUntil(this.destroy$)
    ).subscribe();
  }
  constructor(
    translate: TranslateService,
    private readonly titleService: Title,
    private readonly extensionService: ExtensionService,
    private readonly router: Router,
    private readonly extensionMessageSubscriber: ExtensionMessageSubscriberService,
    private readonly extensionMessagePublisher: ExtensionMessagePublisherService
  ) {
    this.setTitle("EPP");
    translate.addLangs(["en", "fr"]);
    translate.setDefaultLang("en");

    const browserLang: string = translate.getBrowserLang();
    translate.use(browserLang.match(/en|fr/) ? browserLang : "en");
  }

  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  ngOnInit(): void {
    window.addEventListener("message", this.setDataValue.bind(this));
    this.subscribeToDataValue();
    this.extensionMessagePublisher.publishAppComponentInitialized();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
